module.exports = __webpack_public_path__ + "img/cqjtdxLogo.f6ba7013.png";